// import emailjs from '@emailjs/browser';
// import { useEffect, useRef, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { useLocation } from 'react-use';
// import { getAsync } from '../../../components/helper/axiosHelper';
// import { PageHitCountApi } from '../../../shared/Helper';

// const Physicaldonations = () => {
//   const isActive = useSelector((state) => state.toggle.isActive);
//   const [emiratesAPIData, setEmiratesAPIData] = useState([]);
//   const [selectedEmiratesID, setSelectedEmiratesID] = useState(0);
//   const { t } = useTranslation();

//   const form = useRef();
//   const { pathname } = useLocation();

//   useEffect(() => {
//     PageHitCountApi(pathname, 0);
//   }, []);

//   const sendEmail = (e) => {
//     e.preventDefault();

//     emailjs
//       .sendForm('service_opzkl1l', 'template_466awgf', form.current, {
//         publicKey: 'qCEuGb7HiW-JHmThv',
//       })
//       .then(
//         () => {
//           toast.success(`${t('Success!')}`);
//         },
//         (error) => {
//           console.log('FAILED...', error.text);
//         },
//       );
//   };
//   const getEmirates = async () => {
//     await getAsync('Utilities/GetEmiratesList')
//       .then((response) => {
//         const result = response?.data;
//         setEmiratesAPIData(result);
//       })
//       .catch((error) => {
//         toast.error(t('Something went wrong, Please try again!'));
//       });
//   };
//   const handleOnSelectEmirate = (selectedEmirates) => {
//     const emirates = selectedEmirates.target.value;
//     if (emirates == null || emirates == undefined || emirates == 0) {
//       setSelectedEmiratesID(0);
//     }
//     setSelectedEmiratesID(emirates);
//   };

//   useEffect(() => {
//     localStorage.setItem('isHome', true);
//     getEmirates();
//   }, []);
//   return (
//     <>
//       <div className="">
//         <div className="h-90 ">
//           <img src="/assets/images/seabanner.jpg" className="sm:pb-4 h-60 lg:h-80 w-full relative" alt="" />
//           <div className="absolute top-32 lg:top-52 w-full ">
//             <h2 className={`text-white text-3xl text-center flex w-full justify-center font-bold py-3 `}>
//               {' '}
//               {isActive ? 'التبرعات العينية' : 'Physical Donations'}
//             </h2>
//           </div>
//         </div>
//         <section className={`sm:h-90 flex lg:flex-row flex-col pt-5 lg:px-10 ${isActive ? 'text-left' : 'text-right'}`}>
//           <div className="px-5 lg:px-0 pt-2">
//             <h2
//               className={`text-customgreen text-2xl flex font-bold py-1  ${isActive ? 'justify-right ' : 'text-left '}`}
//             >
//               {isActive ? ' إن بعض ما عندكم ,هو كل ما عندهم' : 'Some of what you have is everything they have.'}
//             </h2>
//             <h4 className={`text-customgreen flex sm:text-2xl pt-4 text-justify `}>
//               {isActive
//                 ? `يمكنك الآن طلب محصل لتلقي تبرعاتك العينية( الألبسة ، الأحذية ، العاب الأطفال ،الأثاث المنزلي
//               والمكتبي،الأجهزة والإلكترونية المجوهرات والسيارات ... الخ) قم بملأ الطلب وسوف يتم التواصل معك لتحديد
//               الموعد`
//                 : ` You can now request a collector to receive your in-kind donations (clothing, shoes, children's toys, household and office furniture, electronic devices, jewelry, cars, etc.). Fill out the request form, and we will contact you to schedule a pickup.`}
//             </h4>
//           </div>
//         </section>
//         <form className="py-5 lg:px-10" ref={form} onSubmit={sendEmail} id="contact-form" noValidate="novalidate">
//           <div className="container lg:px-0 px-5  sm:pb-1">
//             <div className="row">
//               <div className="col-md-6">
//                 <div className="form-group py-2">
//                   <label className="font-semibold text-gray-800 p-2">
//                     {t('Donor Type')}
//                     <span className="errmsg">*</span>
//                   </label>
//                   <input
//                     name="donor_Type"
//                     className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
//                     type="text"
//                   />
//                 </div>
//                 <div className="form-group py-2">
//                   <label className="font-semibold text-gray-800 p-2">
//                     {t('Emirates')}
//                     <span className="errmsg">*</span>
//                   </label>

//                   <select
//                     value={selectedEmiratesID}
//                     onChange={(selectedEmiratesID) => handleOnSelectEmirate(selectedEmiratesID)}
//                     className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
//                     name="emirate"
//                   >
//                     <option value="0">--{t('SELECT')}--</option>
//                     {emiratesAPIData && emiratesAPIData.length > 0 ? (
//                       emiratesAPIData?.map((item) => (
//                         <option key={item.emiratesID} value={item.emiratesID}>
//                           {t(isActive ? item?.ar_SA : item?.en_US)}
//                         </option>
//                       ))
//                     ) : (
//                       <option>No Emirates found</option>
//                     )}
//                   </select>
//                 </div>

//                 <div className="form-group py-2">
//                   <label className="font-semibold text-gray-800 p-2">
//                     {t('LandLine Number')}
//                     <span className="errmsg">*</span>
//                   </label>
//                   <input
//                     className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
//                     type="text"
//                     name="landLine_Number"
//                     onInput={(event) => {
//                       const { value } = event.target;
//                       // const regex = /^\d+(\.\d{0,2})?$/;
//                       const regex = /^\+?\d*$/;
//                       if (regex.test(value)) {
//                       } else {
//                         event.target.value = value.slice(0, -1);
//                       }
//                     }}
//                   />
//                 </div>

//                 <div className="form-group py-2">
//                   <label className="font-semibold text-gray-800 p-2">
//                     {t('Email')}
//                     <span className="errmsg">*</span>
//                   </label>
//                   <input
//                     className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
//                     type="text"
//                     name="user_email"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-6">
//                 <div className="form-group py-2">
//                   <label className="font-semibold text-gray-800 p-2">
//                     {t('Donor Name')}
//                     <span className="errmsg">*</span>
//                   </label>
//                   <input
//                     className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
//                     type="text"
//                     name="donor_name"
//                   />
//                 </div>
//                 <div className="form-group py-2">
//                   <label className="font-semibold text-gray-800 p-2">
//                     {t('Address')}
//                     <span className="errmsg">*</span>
//                   </label>
//                   <input
//                     className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
//                     type="text"
//                     name="address"
//                   />
//                 </div>

//                 <div className="form-group py-2">
//                   <label className="font-semibold text-gray-800 p-2">
//                     {t('Mobile Number')}
//                     <span className="errmsg">*</span>
//                   </label>
//                   <input
//                     className=" border border-customgreen focus:ring-customgreen hover:focus:border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
//                     type="text"
//                     name="mobile_num"
//                     onInput={(event) => {
//                       const { value } = event.target;
//                       // const regex = /^\d+(\+\d{0,2})?$/;
//                       const regex = /^\+?\d*$/;
//                       if (regex.test(value)) {
//                       } else {
//                         event.target.value = value.slice(0, -1);
//                       }
//                     }}
//                   />
//                   <p className="mt-2 text-sm">{t('Your mobile number should starts with +971.')}</p>
//                 </div>

//                 <div className="form-group py-2">
//                   <label className="font-semibold text-gray-800 p-2">
//                     {t('Donor Detail')}
//                     <span className="errmsg">*</span>
//                   </label>
//                   <input
//                     className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
//                     type="text"
//                     name="donor_detail"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-md-12 col-sm-12 form-group text-center">
//             <button
//               className="text-white bg-customorange hover:bg-customorange/90 focus:ring-4 focus:outline-none focus:ring-customgreen/50 font-medium rounded-3xl text-sm px-5 py-2.5 text-center inline-flex items-center  me-2 mb-2"
//               type="submit"
//               name="submit-form"
//             >
//               <span className="btn-title">{t('Send')}</span>
//             </button>
//           </div>
//         </form>
//       </div>
//     </>
//   );
// };
// export default Physicaldonations;

import emailjs from '@emailjs/browser';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { getAsync, postAsync } from '../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../shared/Helper';
import { z } from 'zod';

const formSchema = z.object({
  donorType: z.string().min(1, 'Donor Type is required'),
  emirates: z.string().refine((val) => val !== '0' && val !== '', {
    message: 'Emirate is required',
  }),
  landLineNumber: z.string().min(1, 'Landline Number is required'),
  email: z.string().min(1, 'Email is required'),
  donorName: z.string().min(1, 'Donor Name is required'),
  address: z.string().min(1, 'Address is required'),
  mobileNumber: z.string().min(1, 'Mobile Number is required'),
  donorDetail: z.string().min(1, 'Donor Detail is required'),
});
const Physicaldonations = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [emiratesAPIData, setEmiratesAPIData] = useState([]);
  const [selectedEmiratesID, setSelectedEmiratesID] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    donorType: '',
    donorName: '',
    emirates: '',
    address: '',
    mobileNumber: '',
    landLineNumber: '',
    email: '',
    donorDetail: '',
  });
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const form = useRef();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormErrors({ ...formErrors, [name]: '' });
  };
  const sendEmail = async (e) => {
    e.preventDefault();
    const result = formSchema.safeParse(formData);

    if (!result.success) {
      const newErrors = {};
      result.error.errors.forEach((err) => {
        newErrors[err.path[0]] = err.message;
      });
      setFormErrors(newErrors);
      return;
    }

    try {
      const encodedBody = encodeURIComponent(JSON.stringify(formData));
      const response = await postAsync(
        `APIClient/ContactUs?subject=${encodeURIComponent('Contact Us')}&body=${encodedBody}`,
      );

      if (response.statusCode === 200) {
        toast.success(t('Email sent successfully'));
        setFormErrors({});
        form.current.reset();
        setFormData({
          donorType: '',
          donorName: '',
          emirates: '',
          address: '',
          mobileNumber: '',
          landLineNumber: '',
          email: '',
          donorDetail: '',
        });

      }
    } catch (error) {
      console.log(error);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   if (!validateForm()) {
  //     toast.error(t('Please fill all fields'));
  //     return;
  //   }

  //   emailjs
  //     .sendForm('service_opzkl1l', 'template_466awgf', form.current, {
  //       publicKey: 'qCEuGb7HiW-JHmThv',
  //     })
  //     .then(
  //       () => {
  //         toast.success(`${t('Success!')}`);
  //       },
  //       (error) => {
  //         console.log('FAILED...', error.text);
  //       },
  //     );
  // };

  const getEmirates = async () => {
    await getAsync('Utilities/GetEmiratesList')
      .then((response) => {
        const result = response?.data;
        setEmiratesAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', true);
    getEmirates();
  }, []);

  return (
    <>
      <div className="">
        <div className="h-90 ">
          <img src="/assets/images/seabanner.jpg" className="sm:pb-4 h-60 lg:h-80 w-full relative" alt="" />
          <div className="absolute top-32 lg:top-52 w-full ">
            <h2 className={`text-white text-3xl text-center flex w-full justify-center font-bold py-3 `}>
              {' '}
              {isActive ? 'التبرعات العينية' : 'Physical Donations'}
            </h2>
          </div>
        </div>
        <section className={`sm:h-90 flex lg:flex-row flex-col pt-5 lg:px-10 ${isActive ? 'text-left' : 'text-right'}`}>
          <div className="px-5 lg:px-0 pt-2">
            <h2
              className={`text-customgreen text-2xl flex font-bold py-1  ${isActive ? 'justify-right ' : 'text-left '}`}
            >
              {isActive ? ' إن بعض ما عندكم ,هو كل ما عندهم' : 'Some of what you have is everything they have.'}
            </h2>
            <h4 className={`text-customgreen flex sm:text-2xl pt-4 text-justify `}>
              {isActive
                ? `يمكنك الآن طلب محصل لتلقي تبرعاتك العينية( الألبسة ، الأحذية ، العاب الأطفال ،الأثاث المنزلي
              والمكتبي،الأجهزة والإلكترونية المجوهرات والسيارات ... الخ) قم بملأ الطلب وسوف يتم التواصل معك لتحديد
              الموعد`
                : ` You can now request a collector to receive your in-kind donations (clothing, shoes, children's toys, household and office furniture, electronic devices, jewelry, cars, etc.). Fill out the request form, and we will contact you to schedule a pickup.`}
            </h4>
          </div>
        </section>
        <form className="py-5 lg:px-10" ref={form} onSubmit={sendEmail} id="contact-form" noValidate="novalidate">
          <div className="container lg:px-0 px-5  sm:pb-1">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group py-2">
                  <label className="font-semibold text-gray-800 p-2">
                    {t('Donor Type')}
                    <span className="errmsg">*</span>
                  </label>
                  <input
                    name="donorType"
                    className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
                    type="text"
                    onChange={handleChange} // Validate on change
                  />
                  {formErrors.donorType && <p className="text-red-500 text-sm">{t(`${formErrors.donorType}`)}</p>}
                </div>
                <div className="form-group py-2">
                  <label className="font-semibold text-gray-800 p-2">
                    {t('Emirates')}
                    <span className="errmsg">*</span>
                  </label>

                  <select
                    value={formData?.emirates}
                    onChange={handleChange} // Validate on change
                    className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
                    name="emirates"
                  >
                    <option value="0">--{t('SELECT')}--</option>
                    {emiratesAPIData && emiratesAPIData.length > 0 ? (
                      emiratesAPIData?.map((item) => (
                        <option key={item.emiratesID} value={isActive ? item?.ar_SA : item?.en_US}>
                          {t(isActive ? item?.ar_SA : item?.en_US)}
                        </option>
                      ))
                    ) : (
                      <option>No Emirates found</option>
                    )}
                  </select>
                  {formErrors.emirates && <p className="text-red-500 text-sm">{t(`${formErrors.emirates}`)}</p>}
                </div>

                <div className="form-group py-2">
                  <label className="font-semibold text-gray-800 p-2">
                    {t('LandLine Number')}
                    <span className="errmsg">*</span>
                  </label>
                  <input
                    className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
                    type="text"
                    name="landLineNumber"
                    onChange={handleChange} // Validate on change
                    onInput={(event) => {
                      const { value } = event.target;
                      const regex = /^\+?\d*$/;
                      if (!regex.test(value)) {
                        event.target.value = value.slice(0, -1);
                      }
                    }}
                  />
                  {formErrors?.landLineNumber && (
                    <p className="text-red-500 text-sm">{t(`${formErrors?.landLineNumber}`)}</p>
                  )}
                </div>

                <div className="form-group py-2">
                  <label className="font-semibold text-gray-800 p-2">
                    {t('Email')}
                    <span className="errmsg">*</span>
                  </label>
                  <input
                    className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
                    type="text"
                    name="email"
                    onChange={handleChange} // Validate on change
                  />
                  {formErrors.email && <p className="text-red-500 text-sm">{t(`${formErrors.email}`)}</p>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group py-2">
                  <label className="font-semibold text-gray-800 p-2">
                    {t('Donor Name')}
                    <span className="errmsg">*</span>
                  </label>
                  <input
                    className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
                    type="text"
                    name="donorName"
                    onChange={handleChange} // Validate on change
                  />
                  {formErrors.donorName && <p className="text-red-500 text-sm">{t(`${formErrors.donorName}`)}</p>}
                </div>
                <div className="form-group py-2">
                  <label className="font-semibold text-gray-800 p-2">
                    {t('Address')}
                    <span className="errmsg">*</span>
                  </label>
                  <input
                    className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
                    type="text"
                    name="address"
                    onChange={handleChange} // Validate on change
                  />
                  {formErrors.address && <p className="text-red-500 text-sm">{t(`${formErrors.address}`)}</p>}
                </div>

                <div className="form-group py-2">
                  <label className="font-semibold text-gray-800 p-2">
                    {t('Mobile Number')}
                    <span className="errmsg">*</span>
                  </label>
                  <input
                    className=" border border-customgreen focus:ring-customgreen hover:focus:border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                    type="text"
                    name="mobileNumber"
                    onChange={handleChange} // Validate on change
                    onInput={(event) => {
                      const { value } = event.target;
                      const regex = /^\+?\d*$/;
                      if (!regex.test(value)) {
                        event.target.value = value.slice(0, -1);
                      }
                    }}
                  />
                  <p className="mt-2 text-sm">{t('Your mobile number should starts with +971.')}</p>
                  {formErrors.mobileNumber && <p className="text-red-500 text-sm">{t(`${formErrors.mobileNumber}`)}</p>}
                </div>

                <div className="form-group py-2">
                  <label className="font-semibold text-gray-800 p-2">
                    {t('Donor Detail')}
                    <span className="errmsg">*</span>
                  </label>
                  <input
                    className=" border border-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:ring-customgreen hover:focus:border-customgreen"
                    type="text"
                    name="donorDetail"
                    onChange={handleChange} // Validate on change
                  />
                  {formErrors.donorDetail && <p className="text-red-500 text-sm">{t(`${formErrors.donorDetail}`)}</p>}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 form-group text-center">
            <button
              className="text-white bg-customorange hover:bg-customorange/90 focus:outline-none  font-medium rounded-3xl text-sm px-5 py-2.5 text-center inline-flex items-center  me-2 mb-2"
              type="submit"
              name="submit-form"
            >
              <span className="btn-title">{t('Send')}</span>
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
export default Physicaldonations;
